export default __webpack_public_path__ + "static/media/push39.167c52b3.gif";